import React from 'react';
import styled from 'styled-components';
import Select, { components } from 'react-select';
import { FilterIcon } from '@/components/client/contracts';

interface IProps {
  options: any;
  selectedValue: unknown[];
  controlShouldRenderValue: boolean;
  disabled: boolean;
  onSelectOptions: any;
  label: string;
  isSingleSelect?: boolean;
  width?: string;
  minWidth?: string;
  disableDefaultSelectedStyle?: boolean;
  hideBorder?: boolean;
  expandContentOnOpen?: boolean;
  showLabels?: boolean;
}

const ValueContainer = (props: any) => {
  let [values] = props.children;
  const { label } = props.selectProps;

  let length = 0;
  if (Array.isArray(values)) {
    length = values.length;

    values = props.options.length !== length ? length.toString() + ' selected' : 'All selected';
  }
  return (
    <components.ValueContainer {...props}>
      {props.label}
      <div
        style={{
          width: '100%',
          paddingTop: '8px',
        }}
      >
        <div
          style={{
            float: 'left',
            fontSize: '16px',
          }}
        >
          {label} &nbsp;
        </div>
        <span
          style={{
            color: 'grey',
            float: 'right',
            fontSize: '13px',
          }}
        >
          {length > 0 && values}
        </span>
        <div
          style={{
            display: 'content',
          }}
        >
          {props.children[1]}
        </div>
      </div>
    </components.ValueContainer>
  );
};

const FilterControl = ({
  options,
  controlShouldRenderValue,
  onSelectOptions,
  selectedValue,
  disabled,
  label,
  isSingleSelect,
  width,
  minWidth,
  disableDefaultSelectedStyle,
  hideBorder,
  expandContentOnOpen,
  showLabels,
}: IProps): React.ReactElement => {
  const Option = (props: any) => {
    return (
      <div className="checkbox-items">
        <components.Option {...props}>
          <input
            type="checkbox"
            checked={props.isSelected}
            onChange={() => null}
            style={{
              display: 'inline-block',
              width: 18,
              height: 18,
              margin: 3,
              marginRight: 12,
              verticalAlign: 'middle',
            }}
          />
          <label style={{ fontSize: '14px' }}>{props.label}</label>
        </components.Option>
      </div>
    );
  };

  const handleChange = (selected: unknown) => {
    onSelectOptions(selected);
  };

  const CustomStyleWithValue = {
    control: (base: { [key: string]: string }) => ({
      ...base,
      height: '45px',
    }),
  };

  const CustomSelectedOptionStyle = {
    clearIndicator: (provided: { [key: string]: string }) => ({
      ...provided,
      display: 'none', // Hide the crossmark
    }),
    control: (base: { [key: string]: string }) => ({
      ...base,
      height: '45px',
      border: hideBorder ? 'none' : '1px solid lightgrey !important',
      boxShadow: hideBorder ? 'none' : '1px solid lightgrey !important',
    }),
    menu: (base: { [key: string]: string }) => ({
      ...base,
      position: expandContentOnOpen ? 'inherit' : 'absolute',
    }),
    option: (base: { [key: string]: string }) => ({
      ...base,
      color: '#135188',
      backgroundColor: 'white',
      fontFamily: 'Barlow',
      fontStyle: 'normal',
      fontWeight: '600',
      fontSize: '13px',
      '&:hover': { backgroundColor: '#ebf3f6' },
      '&:active': { backgroundColor: 'white' },
    }),
    multiValue: (styles: any) => {
      return {
        ...styles,
        backgroundColor: '#FFFFFF',
      };
    },
    multiValueLabel: (styles: any) => ({
      ...styles,
      display: 'inline-flex',
      color: '#FFFFFF',
      backgroundColor: '#008ACD',
      borderRadius: '24px 0 0 24px',
      padding: '8px 8px 8px 16px',
      gap: '8px',
    }),
    multiValueRemove: (styles: any) => ({
      ...styles,
      color: '#FFFFFF',
      backgroundColor: '#008ACD',
      borderRadius: '0 24px 24px 0',
      cursor: 'pointer',
      ':hover': {
        backgroundColor: '#008ACD',
        color: 'white',
      },
    }),
  };

  const customStyles = {
    clearIndicator: (provided: { [key: string]: string }) => ({
      ...provided,
      display: 'none', // Hide the crossmark
    }),
    option: (base: { [key: string]: string }) => ({
      ...base,
      color: '#135188',
      backgroundColor: 'white',
      outline: 'none',
      border: 0,
    }),
    menu: (base: any) => ({
      ...base,
      width: 'max-content',
      minWidth: 40,
      outline: 'none',
      position: expandContentOnOpen ? 'inherit' : 'absolute',
      '&:hover': { backgroundColor: 'white' },
      '&:focus': { outline: 'none' },
      '&:active': { outline: 'none' },
    }),
    control: (base: { [key: string]: string }) => ({
      ...base,
      border: '1px solid lightgrey !important',
      boxShadow: '1px solid lightgrey !important',
      '&:hover': {
        border: '1px solid lightgrey !important',
      },
      width: 46,
      height: 46,
      margin: '-3px 0 0 10px',
      backgroundColor: `${disabled ? '#adb5bd' : '#fff'}`,
      '[class*="-indicatorContainer"]': { padding: '6px' },
    }),
  };

  const DropdownIndicator = (props: any) => {
    return (
      <components.DropdownIndicator {...props} style={{ height: 40, padding: 0, margin: 0 }}>
        <FilterIcon
          style={{
            padding: 0,
            margin: 0,
            marginTop: -30,
            marginLeft: 0,
            backgroundColor: `${disabled ? '#fff' : '#0087dd'}`,
          }}
        />
      </components.DropdownIndicator>
    );
  };

  return (
    <Container>
      {controlShouldRenderValue === false ? (
        <div style={{ width: 50 }}>
          <Select
            components={{ Option, DropdownIndicator, IndicatorSeparator: () => null, ClearIndicator: () => null }}
            options={options}
            isMulti
            closeMenuOnSelect={false}
            hideSelectedOptions={false}
            onChange={event => {
              handleChange(event);
            }}
            value={selectedValue}
            allowSelectAll={true}
            controlShouldRenderValue={false}
            styles={customStyles}
            placeholder={null}
            filterOption={null}
            onPointerCancel={null}
            blurInputOnSelect={false}
            isSearchable={false}
            isDisabled={disabled}
          />
        </div>
      ) : (
        <div style={{ width: width, minWidth: minWidth }}>
          <Select
            label={label}
            placeholder={isSingleSelect ? label : ''}
            components={
              isSingleSelect
                ? { IndicatorSeparator: () => null, ClearIndicator: () => null }
                : showLabels
                ? { Option }
                : { ValueContainer, Option }
            }
            options={options}
            isMulti={!isSingleSelect}
            closeMenuOnSelect={isSingleSelect ? true : false}
            hideSelectedOptions={false}
            onChange={event => {
              handleChange(event);
            }}
            allowSelectAll={true}
            controlShouldRenderValue={true}
            blurInputOnSelect={false}
            styles={disableDefaultSelectedStyle ? CustomSelectedOptionStyle : CustomStyleWithValue}
            value={selectedValue}
            isClearable={true}
          />
        </div>
      )}
    </Container>
  );
};

export { FilterControl };

const Container = styled.div``;
